import { useRef } from 'react'
import {
    View,
    Text,
    ActivityIndicator,
    ScrollView
} from 'react-native'
import { globalStyles, fontPalette } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'
import RadioGroup from 'react-native-radio-buttons-group';

const EEOInformationForm = ({ navigation, route }: any): JSX.Element => {
    const formikRef = useRef(null)
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params
    const checkboxData = [
        { value: "1", id: "1", label: 'American Indian or Alaskan' },
        { value: "2", id: "2", label: 'Asian' },
        { value: "3", id: "3", label: 'Black' },
        { value: "4", id: "4", label: 'Hispanic or Latino' },
        { value: "5", id: "5", label: 'White - Not of Hispanic Origin' },
        { value: "6", id: "6", label: 'Native Hawaiian or Pac Island' },
        { value: "7", id: "7", label: 'Two or More Races' },
        { value: "8", id: "8", label: `I do not wish to disclose` },
    ];
    const intialValues = {
        ethnicity: ""
    }
    const alschema = yup.object({
        ethnicity: yup.mixed().required("Ethnicity is a required field")
    })
    const { loading, postEEOOnline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    return (
        <ScrollView>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'Equal Employment Opportunity Form'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={alschema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            completeOnline: mode === 'upload' ? false : true,
                            essUserKey: initializestore.initializeData.userkey,
                            entityId: personalstore.personalData?.entityId,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            essObKey: essUserOnBoardingKey,
                            selectednum: Number(values?.ethnicity)
                        }

                        const response = await postEEOOnline(data)

                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('EEOInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        }
                        else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                    {(props) => (
                        <>
                            <Card>

                                <View
                                    style={[
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Select your Race / Ethnicity *'
                                            }
                                        </Text>
                                    </View>


                                    <RadioGroup
                                        radioButtons={checkboxData}
                                        onPress={(option: any) => props.setFieldValue("ethnicity", option)}
                                        selectedId={props.values.ethnicity}
                                        labelStyle={{ color: "#0B495C", fontSize: 14, fontFamily: fontPalette.primaryRegular }}
                                        containerStyle={{ padding: 10, flexDirection: 'column', alignItems: 'flex-start' }}
                                    />

                                    {props.touched.ethnicity &&
                                        props.errors.ethnicity && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.ethnicity as string}
                                            </Text>
                                        )}
                                </View>

                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}


                            </Card>
                        </>
                    )}
                </Formik>
            </View>

        </ScrollView>
    )
}
export default EEOInformationForm
